type VariantMap<Variants extends Record<string, Record<string, string>>> = {
  [K in keyof Variants]?: keyof Variants[K] | undefined;
};

type CompoundVariant<Variants extends Record<string, Record<string, string>>> =
  VariantMap<Variants> & { className: string };

export function cva<
  Variants extends Record<string, Record<string, string>>,
>(config: {
  base?: string | string[];
  variants?: Variants;
  defaultVariants?: VariantMap<Variants>;
  compoundVariants?: Array<CompoundVariant<Variants>>;
}) {
  const {
    base = "",
    variants = {} as Variants,
    defaultVariants = {} as VariantMap<Variants>,
    compoundVariants = [],
  } = config;

  const baseStr = Array.isArray(base) ? base.filter(Boolean).join(" ") : base;

  return function resolve(user?: VariantMap<Variants>): string {
    const resolved: VariantMap<Variants> = { ...defaultVariants, ...user };
    const parts: string[] = [baseStr];

    for (const key in variants) {
      const variantKey = key as keyof Variants;
      const option = resolved[variantKey];
      if (!option) continue;
      const map = variants[variantKey];
      const cls = map?.[option as string];
      if (cls) parts.push(cls);
    }

    for (const entry of compoundVariants) {
      let matches = true;
      for (const k in variants) {
        const expect = (entry as any)[k];
        if (expect === undefined) continue;
        if ((resolved as any)[k] !== expect) {
          matches = false;
          break;
        }
      }
      if (matches && entry.className) parts.push(entry.className);
    }

    return parts.filter(Boolean).join(" ");
  };
}

export default cva;
